import * as S from './styles';
import { Icon } from '@iconify/react';

import { connectUtil, PropsFromRedux } from 'base/src/utils/reduxUtil';
import { formatToBRL } from 'base/src/utils/mathUtil';

import { useEffect, useState } from 'react';
import { Button } from 'base/src/components/Button';
import { useCarteira } from '../../../utils/context/carteiraBaseContext';
import { RootStateBaseCarteira } from '../../../store/_carteira/carteiraBaseReducer';
import { GetCarteiraBase, UpdateCarteiraBase } from '../../../store/_carteira/carteiraBase/actions/carteiraBaseAction';

// Interface genérica para estados que tenham CarteiraBase


const connector = connectUtil(
  (state: RootStateBaseCarteira) => ({
    homeInfo: state.CarteiraBaseReducer.CarteiraBase,
  }),
  { GetCarteiraBase, UpdateCarteiraBase }
);

export interface CarteiraValorComponentProps extends PropsFromRedux<typeof connector> {
}

function CarteiraValor(props: CarteiraValorComponentProps) {
  const { walletBalance } = useCarteira();
  const [hide, setHide] = useState<boolean>(false);

  function HandleHide() {

    props.UpdateCarteiraBase(
      {
        ...props.homeInfo,
        EsconderSaldo: !props.homeInfo.EsconderSaldo
      });
  }

  useEffect(() => {
    if (props.homeInfo !== null) {
      setHide(props.homeInfo.EsconderSaldo);
    }
  }, [props.homeInfo.EsconderSaldo]);


  function GetText(): string | undefined {
    return hide ? 'R$ *****,**' : formatToBRL(walletBalance || 0);
  }


  return (
    <>
      {
        props.homeInfo !== null &&
        <S.Container>
          <S.ValueContainer>
            <S.Text>Saldo em Conta</S.Text>
            {/* <S.Valor data-testid={"carteira-valor"}>{formatToBRL(walletBalance || 0)}</S.Valor> */}
            <S.Valor data-testid={"carteira-valor"}>{GetText()}</S.Valor>
          </S.ValueContainer>
          <Button onClick={HandleHide} variant='tertiary' size='sm' style={{ padding: 0 }}>
            {
              hide ?
                <Icon icon='ion:eye-off-outline' height={25} />
                :
                <Icon icon='ion:eye-outline' height={25} />
            }
          </Button>
          {/* <Icon icon='ion:eye-off-outline' height={25} /> */}
        </S.Container>
      }
    </>
  );
}

export default connector(CarteiraValor);